import { PollControlProps } from './types';

export const PollControl = ({ children }: PollControlProps) => <>{children}</>;
